var render = function render(){var _vm=this,_c=_vm._self._c;return _c('level-formulae',{attrs:{"level-formulae":_vm.levelFormulae,"entities-by-id":_vm.entitiesById,"is-loading":_vm.isLoading},on:{"reload":_vm.onReload}})
}
var staticRenderFns = []

export { render, staticRenderFns }